import { Component } from '@angular/core';

@Component({
  selector: 'app-talker-testimonial',
  templateUrl: './talker-testimonial.component.html'
})
export class TalkerTestimonialComponent {

}
